<template>
  <pui-file-thumbnail-viewer
    v-on="$listeners"
    v-bind="$attrs"
    :src="src"
    :fallbackText="extension"
  ></pui-file-thumbnail-viewer>
</template>

<script>
export { ObjectFit } from '../../../common/components/thumbnail/FileThumbnailViewer';

export default {
  name: 'pui-dam-file-viewer',
  props: {
    file: {
      type: Object,
      required: true,
    },
    /**
     * If we should display the preview instead of the thumbnail
     *
     * @type {Boolean}
     * @default false
     */
    hd: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * @returns {string} The url to the file thumbnail
     */
    src() {
      let src = '';
      if (this.hd) {
        src =
          !!this.file && !!this.file.previews && !!this.file.previews.length
            ? this.file.previews[0]
            : '';
      } else {
        src =
          !!this.file && !!this.file.thumbnails && !!this.file.thumbnails.length
            ? this.file.thumbnails[0]
            : '';
      }

      // When in development, when url is absolute, it needs to be changed to a relative url
      // to be proxied so we can send the cookies corresponding to our domain
      if (process.env.NODE_ENV === 'development' && src && src.startsWith('http')) {
        return new URL(src).pathname;
      }

      return src || '';
    },
    /**
     * @returns {string} the extension of the file
     */
    extension() {
      return this.file.description ? this.file.description.extension : '' || '';
    },
  },
};
</script>
